import { HistoryOutlined } from '@ant-design/icons';
import { Button, Table } from 'antd';
import DownloadComponent from 'components/Global/Download';
import Ellipse from 'components/Global/Ellipse';
import { useSelector } from 'react-redux';
import { formatNumber, invalidText } from 'utils/utils';
const { Column } = Table;

type Props = {
	compensationLatestData: any;
	isLoading: boolean;
	showModal: () => void;
	totalRecords: number;
};

const CompensationLatestTable = (props: Props) => {
	const { compensationLatestData, isLoading, showModal, totalRecords } =
		props;

	const { data } = useSelector((state: any) => state?.userProfile);

	const { data: profileData } = useSelector(
		(state: any) => state?.userProfile
	);

	return (
		<div>
			<Table
				dataSource={compensationLatestData}
				rowKey={(record) => record.id}
				loading={isLoading}
				pagination={false}
				style={{
					width: '100%',
				}}
			>
				<Column
					title="Statutory Year"
					dataIndex="statutoryYear"
					key="statutoryYear"
					className="bg-white"
					width={'16%'}
					render={(value) => {
						return value;
					}}
				/>
				<Column
					title="Compensation Limit"
					dataIndex="compensationLimit"
					key="compensationLimit"
					className="bg-white"
					width={'18%'}
					render={(value: string) => {
						return formatNumber(
							Number(value),
							data?.CompanyCurrencies
						);
					}}
				/>
				<Column
					title="Updated By"
					dataIndex="createdBy"
					key="createdBy"
					className="bg-white"
					width={'15%'}
					render={(text) => text?.fullName}
				/>
				<Column
					title="Notes"
					dataIndex="notes"
					key="notes"
					sorter={true}
					className="bg-white"
					render={(text, record: { id: string }) =>
						invalidText(text) ? (
							'-'
						) : (
							<Ellipse
								message={text}
								maxLength={20}
								key={record.id}
								tooltipMessage={text}
								isTooltip={true}
							/>
						)
					}
				/>
				<Column
					title="Attachment"
					dataIndex="attachment"
					key="attachment"
					className="bg-white"
					width={'18%'}
					render={(text, record: any) => (
						<div>
							{record.documentName ? (
								<div>
									<DownloadComponent
										documentUrl={record.documentUrl}
										showTooltip={true}
										downloadText={record.documentName}
										text={record.documentName}
										isLink={true}
										maxLength={20}
									/>
								</div>
							) : (
								'-'
							)}
						</div>
					)}
				/>
				{totalRecords >= 1 && (
					<Column
						title="History"
						dataIndex="history"
						key="history"
						className="bg-white"
						render={() => (
							<Button
								type="link"
								icon={<HistoryOutlined />}
								onClick={showModal}
							/>
						)}
					/>
				)}
			</Table>
		</div>
	);
};

export default CompensationLatestTable;
